<!-- Left / centre content, per screen. -->
<ng-container [ngSwitch]="mode">

	<!-- Dashboard: brand logo + company name. -->
	<div *ngSwitchCase="'dashboard'" class="d-flex align-items-center gap-3">
		<div class="portal-logo dash-logo"><portal-brand-logo></portal-brand-logo></div>
		<span class="dash-company-name">{{ branding.companyName }}</span>
	</div>

	<!-- Project hub: switch-project breadcrumb (→ project list). -->
	<button *ngSwitchCase="'project'" class="detail-breadcrumb" (click)="goList()">
		<span>{{ title }}</span>
		<i class="wq wq-replace"></i>
	</button>

	<!-- Section page: back to the project hub + the section switcher. -->
	<ng-container *ngSwitchCase="'section'">
		<button class="sec-back-btn" (click)="goProject()">
			<i class="wq wq-arrow-left"></i>
			Back
		</button>
		<portal-section-nav [projectId]="projectId" [current]="current" [sections]="sections"></portal-section-nav>
	</ng-container>

</ng-container>

<!-- Common right-hand cluster: notifications + avatar dropdown. -->
<div class="sec-topbar-right">
	<portal-notifications></portal-notifications>
	<div class="portal-avatar portal-header-avatar" (click)="toggleMenu($event)">
		{{ avatarInitials }}
		<div class="dash-menu" *ngIf="menuOpen" (click)="$event.stopPropagation()">
			<!--
				A preview has no account behind it, so there is nothing to edit and nothing to sign out
				of. The server refuses both anyway; hiding them keeps staff off a dead end.
			-->
			<ng-container *ngIf="!preview.ready">
				<button (click)="openProfile()">
					Edit Profile
					<i class="wq wq-edit"></i>
				</button>
				<button (click)="auth.logout()">
					Sign out
					<i class="wq wq-arrow-right"></i>
				</button>
			</ng-container>
			<div class="dash-menu-note" *ngIf="preview.ready">Preview — no account signed in</div>
		</div>
	</div>
</div>
